import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";

export function Placeholder({ title, body }: { title: string; body: string }) {
  const { tenant } = useParams();
  if (!tenant) return null;
  return (
    <>
      <TopBar tenant={tenant} title={title} />
      <div className="app-content">
        <div className="coming-soon">{body}</div>
      </div>
    </>
  );
}
